import type { Msg } from '@halo/chat-sdk-react';
import { formatDuration } from '@halo/utils';
import { useMsgMediaTitle } from '../msg-media-call';

export interface MsgGroupMediaCloseContentProps {
  message: Msg;
  children?: (props: { typeDisplay: string; duration: string }) => React.ReactNode;
}

export const MsgGroupMediaCloseContent = memo(function MsgGroupMediaCloseContent({
  message,
  children,
}: MsgGroupMediaCloseContentProps) {
  const { type, call_started_at, created_at, now_time } = message.payload;
  const { typeDisplay } = useMsgMediaTitle({ type });

  const duration = useMemo(
    () => formatDuration(now_time - (call_started_at || created_at)),
    [now_time, call_started_at, created_at]
  );

  return <>{children?.({ typeDisplay, duration })}</>;
});
